import type { EntregadoresModel } from "../models/entregadoresModel"
import { EntregadoresActionsTypes, type EntregadoresActions } from "./entregadoresActions"

export function entregadoresReducer(
    state: EntregadoresModel,
    action: EntregadoresActions
): EntregadoresModel {
    switch (action.type) {
        case EntregadoresActionsTypes.CARREGAR:
            return { ...state, lista: action.payload }
        default:
            return state
    }
}
